import { render } from "./WithdrawInfo.vue?vue&type=template&id=87e8a18c&scoped=true"
import script from "./WithdrawInfo.vue?vue&type=script&lang=js"
export * from "./WithdrawInfo.vue?vue&type=script&lang=js"

import "./WithdrawInfo.vue?vue&type=style&index=0&id=87e8a18c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87e8a18c"]])

export default __exports__